import axios from "config/axios";

const ENDPOINT = "/file";

export const getFileByPath = (path: string) =>
  axios.get(`${ENDPOINT}?path=${path}`, {
    responseType: "blob",
  });
